import { Injectable, Inject } from '@angular/core';
import { UserService } from '../../services/user.service'
import { Location } from '@angular/common';
import { CookieService } from 'ngx-cookie-service';
import { ConstantsService } from '../../services/constants.service';
import { MainMenuService } from './main-menu.service';
import { TokenInterceptor } from '../../token/token.interceptor'
import { FlashService } from '../../services/flash.service';
import { ApplicationService } from '../../services/application.service';
import { TokenService } from '../../services/token.service';
import { CommonHelperService } from '../../services/helpers/common-helper.service';

@Injectable({
  providedIn: 'root'
})
export class UserInfoService {
  private baseUrl: string;

  userInfo: any = {};

  constructor(
    private tokenInterceptor: TokenInterceptor,
    private userService: UserService,
    private location: Location,
    private cookies: CookieService,
    @Inject('$rootScope') private $rootScope: angular.IRootScopeService & { [name: string]: any },
    @Inject('BASE_URL') baseUrl: string,
    private constants: ConstantsService,
    private mainMenu: MainMenuService,
    private flashService: FlashService,
    private applicationService: ApplicationService,
    private tokenService: TokenService) {
    console.log("logintype", this.GetLoginType());
    if (this.GetLoginType() === this.constants.LoginTypes.Cayuse) {
      this.tokenService.StartRefreshLoop(this.SetGlobalUserData.bind(this));
    }
    this.baseUrl = baseUrl;
  }

  SetLoginType(loginType) {
    this.cookies.set('loginType', loginType);
  }

  GetLoginType() {
    return this.cookies.get('loginType');
  }

  GetUserInfo() {
    var promise = new Promise((resolve, reject) => {
      if (!this.userInfo.userId) {
        return this.userService.GetUserDetails().then((response) => {
          if (response.success) {
            this.setUserInfo(response.data);
            this.updateAppData(this.userInfo.applications);
            this.processLoginType();
            resolve(this.userInfo);
          } else {
            this.Logout();
            reject();
          }
        });
      } else {
        this.processLoginType();
        resolve(this.userInfo);
      };
    });
    return promise;
  }

  GetCayuseData(userId, onePlatformURL) {
    return this.userService.GetOneLoginData(userId, onePlatformURL);
  }

  Logout() {
    window.clearInterval(this.tokenService.GetRefreshIntervalId());

    let loginType = this.userInfo.loginType;

    if (loginType === this.constants.LoginTypes.Cayuse) {
      this.userService.GetCayuseLogoutURL().then(response => {
        if (response.success) {
          sessionStorage.setItem('refreshed', 'false');
          this.clearGlobalUserData();
          location.href = response.data;
        }
      });
    } else {
      this.userService.Logout().then(response => {

        this.clearGlobalUserData();
        this.handleLoginStatus();

        if (loginType === this.constants.LoginTypes.SSO) {
          location.href = this.GetSSOLogoutURL();
        } else if (loginType !== this.constants.LoginTypes.SSO) {
          this.location.go('login');
        }
      });
    }
  }

  SetGlobalUserData(tokenData) {

    this.$rootScope.globals.currentUser = {
      token: tokenData.token,
      // This part for on-prems login is probably unnecessary because refresh token functionality was not properly implemented since AngularJS.
      // refreshToken: tokenData.refreshToken || "",
      expiredDate: tokenData.expiresUtc || this.tokenService.GetNextTokenExpirationDateTime(), // Do not remove. Removing usage of expiredDate here and in route.js somehow breaks Left Navigation Menu and Grid functionalities.
      currentRole: this.userInfo.currentRole,
      sessionId: this.userInfo.sessionId
    };

    this.cookies.set('globals', JSON.stringify(this.$rootScope.globals));
    localStorage.setItem("globals_storage", JSON.stringify(this.$rootScope.globals));
  }

  SwitchSite(id) {
    var promise = new Promise((resolve, reject) => {

      if (this.userInfo.currentSite.Id !== id) {

        var loading = this.flashService.Loading();

        var data = {
          sessionId: this.getSessionId(),
          siteId: id
        };

        this.resetAppInfo();

        this.userService.SwitchSite(data).then((response) => {
          this.processResponceData(response, loading, { resolve, reject });
        });
      } else {
        resolve(this.userInfo);
      }
    });
    return promise;
  }

  SwitchRole(id) {
    var promise = new Promise((resolve, reject) => {

      if (this.userInfo.currentRole.Id !== id) {

        var loading = this.flashService.Loading();

        var data = {
          sessionId: this.getSessionId(),
          roleId: id
        };

        this.resetAppInfo();

        this.userService.SwitchRole(data).then((response) => {
          this.processResponceData(response, loading, { resolve, reject });
        });
      } else {
        resolve(this.userInfo);
      }
    });
    return promise;
  }

  SwitchGroup(id) {
    var promise = new Promise((resolve, reject) => {
      if (this.userInfo.currentGroup.Id !== id) {

        var loading = this.flashService.Loading();
        var data = {
          sessionId: this.getSessionId(),
          groupId: id
        };

        this.resetAppInfo();

        this.userService.SwitchGroup(data).then((response) => {
          this.processResponceData(response, loading, { resolve, reject });
        });
      } else {
        resolve(this.userInfo);
      }
    });
    return promise;
  }

  ChangeApplication(app) {
    if (this.userInfo.selectedApp.id !== app.id) {
      this.setSelectedApp(app);
    }
    return this.userInfo;
  }

  SetExternalAuthenticationLogoutURL(logoutURL: string) {
    this.cookies.set('externalAuthenticationLogoutURL', logoutURL);
  }

  GetSSOLogoutURL(): string {
    let SSOLogoutURL = '';

    let externalAuthenticationLogoutURL = this.cookies.get('externalAuthenticationLogoutURL');

    if (externalAuthenticationLogoutURL && externalAuthenticationLogoutURL.length) {
      SSOLogoutURL = `${this.baseUrl}${externalAuthenticationLogoutURL}`;
    }

    return SSOLogoutURL;
  }


  private processLoginType() {
    switch (this.GetLoginType()) {
      case this.constants.LoginTypes.SSO:
        this.setSSOLoginTypeToGlobalVar(true);

        break;
      default:
        this.setSSOLoginTypeToGlobalVar(false);
    }
  }

  private setSSOLoginTypeToGlobalVar(value: boolean) {
    (<any>window).isSSOLoginType = value;
  }

  private updateAppData(applications, loading?) {
    this.userInfo.errorMessage = false;
    this.userInfo.appList = applications;

    if (this.$rootScope.globals && this.$rootScope.globals.application) {
      this.userInfo.selectedApp = this.$rootScope.globals.application; 
    } else {

      if (this.userInfo.appList.length === 0) {
        this.$rootScope.userDataLoaded = true;
        this.userInfo.errorMessage = true;
        this.flashService.HideProgressBar();
        if (loading) {
          loading.dismiss();
        }
        return;
      }

      this.setSelectedApp(this.userInfo.appList[0]);
    }
  }

  private setSelectedApp(app) {
    this.userInfo.selectedApp = app;
    this.$rootScope.globals.application = app;
    this.cookies.set('globals', JSON.stringify(this.$rootScope.globals));
    localStorage.setItem("globals_storage", JSON.stringify(this.$rootScope.globals));
  }

  private processResponceData(response, loading, deferred) {

    if (response.success) {
      this.setUserInfo(response.data);
      this.updateAppData(this.userInfo.applications, loading);
      if (this.userInfo.selectedApp) {
        this.mainMenu.GetApplicationOptions(this.userInfo.selectedApp.id, true).then(() => {
          loading.dismiss();
          deferred.resolve(this.userInfo);
          window.location.reload();
        });
      } else {
        loading.dismiss();
        deferred.resolve(this.userInfo);
        window.location.reload();
      }
    } else {
      loading.dismiss();
      deferred.reject();
    }
  }

  private resetAppInfo() {
    this.$rootScope.globals.application = null;
    this.cookies.set('globals', JSON.stringify(this.$rootScope.globals));
    localStorage.setItem("globals_storage", JSON.stringify(this.$rootScope.globals));
  }

  private handleLoginStatus() {
    var userSession: any = this.cookies.get('globals') !== '' ? JSON.parse(this.cookies.get('globals')) : JSON.parse(localStorage.getItem('globals_storage'));
    if(userSession && userSession.currentUser) {
      this.userInfo.isLoged = userSession.currentUser && userSession.currentUser.token ? true : false;
      this.userInfo.isAdmin = userSession.currentUser && userSession.currentUser.isAdmin;
    }
  }

  private clearGlobalUserData() {
    this.$rootScope.globals = {};
    this.cookies.delete('globals');
    this.cookies.delete('loginType');
    localStorage.removeItem("globals_storage");
    sessionStorage.clear();
    this.userInfo = {};

    this.tokenInterceptor.token = "";
  }

  private setUserInfo(data) {
    this.userInfo = data;
    this.userInfo.customerLogo = this.userInfo.customerLogo ? 'assets/images/' + (this.userInfo.customerLogo) : null;
    this.handleLoginStatus();
  }

  private getSessionId() {
    return this.$rootScope.globals.currentUser.sessionId;
  }

  GetUserCredentialsStatus() {
    return this.userService.GetUserCredentialsStatus();
  }

}
